module.exports = __webpack_public_path__ + "img/loop-studios.6c50fd74.svg";